import { fetchAsync } from '../utils/fetch';

const fetchTargetTemplate = async (dateId: number) => {
  const result = await fetchAsync(`/api/target/template/${dateId}`, {
    method: 'GET',
    type: 'blob',
    headers: {
      contentType: 'application/octet-stream',
    },
  });
  return result;
};
export default fetchTargetTemplate;
